/**
 * Sticky Header
 * @param   {object/string} opts
 * @return  {object/string}
 */
export default function () {
	const { fn: { getDocumentScrollTop } } = am2;
	let c, currentScrollTop = 0, navbar = document.querySelector('.header--site');

	// Sticky class
	const onScroll = () => {
		if (!header) return;

		if (getDocumentScrollTop() > 1) {
			navbar.classList.add("header--sticky");
		} else {
			navbar.classList.remove("header--sticky");
		}
	};

	// Adjust show hide
	const handleShowHide = () => {
		const a = getDocumentScrollTop();
		const b = navbar.offsetHeight;

		currentScrollTop = a;

		if (c < currentScrollTop && a > b + b) {
			navbar.classList.add('header--up');
		} else if (c > currentScrollTop && !(a <= b)) {
			navbar.classList.remove('header--up');
		}

		c = currentScrollTop;
	};

	const adjustPadding = () => $('.site-container').css('padding-top', navbar.offsetHeight);

	window.onload = () => {
		adjustPadding();
		handleShowHide();
	};

	window.onscroll = () => {
		onScroll();
		handleShowHide();
	};

	window.onresize = am2.fn.debounce(() => {
		onScroll();
		adjustPadding();
		handleShowHide();
	}, 150);
}
